import _regeneratorRuntime from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import { TextDrawer, validTypes } from "./TextDrawer";
export function loadTextShape(engine) {
  var drawer, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, type;

  return _regeneratorRuntime.async(function loadTextShape$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          drawer = new TextDrawer();
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context.prev = 4;
          _iterator = validTypes[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context.next = 13;
            break;
          }

          type = _step.value;
          _context.next = 10;
          return _regeneratorRuntime.awrap(engine.addShape(type, drawer));

        case 10:
          _iteratorNormalCompletion = true;
          _context.next = 6;
          break;

        case 13:
          _context.next = 19;
          break;

        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](4);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 19:
          _context.prev = 19;
          _context.prev = 20;

          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }

        case 22:
          _context.prev = 22;

          if (!_didIteratorError) {
            _context.next = 25;
            break;
          }

          throw _iteratorError;

        case 25:
          return _context.finish(22);

        case 26:
          return _context.finish(19);

        case 27:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, [[4, 15, 19, 27], [20,, 22, 26]]);
}